module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-manifest/gatsby-browser.js'),
      options: {"plugins":[],"name":"ESM Plots","short_name":"ESM Plots","start_url":"/em27","background_color":"#ffffff","theme_color":"#f60948","icon":"src/assets/icons/favicon.ico","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"b068607a0fb0dafaca6ce3afab8dc291"},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
